<template>
  <div class="buttons">
    <div class="butL"
         style="position: absolute; top: 45%;  z-index: 999;cursor: pointer;  left: 3%;"
         @click="butLclick">
      <img alt="Logo" src="../assets/leftbutton.png" style="height: 60px;"/>
    </div>
    <div class="butR"
         style="  position: absolute;  top: 45%;   z-index: 999; cursor: pointer; left: 53%"
         @click="butRclick">
      <img alt="Logo" src="../assets/rightbutton.png" style="height: 60px;"/>
    </div>
  </div>
  <div class="dbeijing" style="background-image: url('haogongzhang.webp');
  width: 100vw;
  height: 100vh;
  /* 绝对定位覆盖全屏 */
  position: fixed;
  top: 0;
  left: 0%;
  z-index: -1;
  /* 背景图等比例填充 */
  background-size: 100% 100%;
  background-position: center center;
  background-repeat: no-repeat;">
  <div
      style="font-size: 33px;width: 100%;position: fixed; left: 50%;top: 15%;  transform: translate(-50%, -50%);  text-align: center;  pointer-events: none;z-index: 999;color: white">
    <h1>好工长</h1>
  </div>
  <div class="box" style="position: relative; z-index: 1;">
    <ul id="oul" >
      <li class="show0">
        <img src="../assets/haogongzhang/chengweitao.jpg"/>
        <div class="name-tag">程伟涛</div>
      </li>
      <li class="show1">
        <img src="../assets/haogongzhang/zhouqiang.jpg"/><div class="name-tag">周强</div>
      </li>
      <li class="show2">
        <img src="../assets/haogongzhang/chenshuyu.jpg"/><div class="name-tag">陈树玉</div>
      </li>
      <li class="show3"><img src="../assets/haogongzhang/lichaozheng.jpg"/>    <div class="name-tag">李朝征</div></li>
      <li class="show4"><img src="../assets/haogongzhang/sunwei.jpg"/>    <div class="name-tag">孙威</div></li>
      <li class="show5"><img src="../assets/haogongzhang/xvyanbo.jpg"/>    <div class="name-tag">徐艳波</div></li>
      <li class="show6"><img src="../assets/haogongzhang/yumaolong.jpg"/>    <div class="name-tag">于茂龙</div></li>
      <li class="show7"><img src="../assets/haogongzhang/zhaosongsong.jpg"/>    <div class="name-tag">赵松松</div></li>
      <li class="show8"><img src="../assets/haogongzhang/zangzhiwei.jpg"/>    <div class="name-tag">臧志伟</div></li>
    </ul>
  </div>
    <div class="back1" style="position: absolute;top: 37%;left: 60%;z-index: 0;width: 250px">
      <div style="position: relative; height: 100%">
        <div style="position: absolute; top: 45%; left: 55%; transform: translate(-50%, -50%); z-index: 1; text-align: left; width: 100%;margin-left: 20px;">
          <div style="font-size: 32px;font-weight: bold">全包整装</div>
          <div style="margin-top: 30px;">由工长全权负责施工,购置全部辅材,全部或部分主材</div>
        </div>
        <img alt="Logo" src="../assets/sjsbeijing.png" style="height: 200px; position: relative; z-index: 0"/>
      </div>
    </div>
    <div class="back2" style="position: absolute;top: 37%;left: 78%;z-index: 0;width: 250px">
      <div style="position: relative; height: 100%">
        <div style="position: absolute; top: 45%; left: 55%; transform: translate(-50%, -50%); z-index: 1; text-align: left; width: 100%;margin-left: 20px">
          <div style="font-size: 32px;font-weight: bold">半包基装</div>
          <div style="margin-top: 30px;text-align: left">业主购置主材、基材,辅材及施工半包给工长</div>
        </div>
        <img alt="Logo" src="../assets/sjsbeijing.png" style="height: 200px; position: relative; z-index: 0"/>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ProjectsList',
  data() {
    return {
      projects: [],
      lists: ["show0", "show1", "show2", "show3", "show4", "show5", "show6", "show7", "show8"],
      flag: true,
      timer: null,
      box: null,
      oli: null,
      butL: null,
      butR: null,
      startX: null,
      startY: null,
    };
  },
  mounted() {
    this.getinfo();
    // 添加触摸事件监听
    document.addEventListener('touchstart', this.handleTouchStart, { passive: false });
    document.addEventListener('touchend', this.handleTouchEnd, { passive: false });
    // 添加滚轮事件监听
    window.addEventListener('wheel', this.handleWheelScroll);
    // 禁用快捷键缩放
    document.addEventListener('keydown', this.handleKeyDown);
    // 禁用双指缩放（移动端）
    document.addEventListener('wheel', this.handleWheel, { passive: false });
    // 禁用触摸事件缩放
    document.addEventListener('touchmove', this.handleTouchMove, { passive: false });
  },
  beforeUnmount() {
    // 移除触摸事件监听
    document.removeEventListener('touchstart', this.handleTouchStart);
    document.removeEventListener('touchend', this.handleTouchEnd);
    // 移除滚轮事件监听
    window.removeEventListener('wheel', this.handleWheelScroll);
    document.removeEventListener('keydown', this.handleKeyDown);
    document.removeEventListener('wheel', this.handleWheel);
    document.removeEventListener('touchmove', this.handleTouchMove);
  },
  computed: {
  },
  methods: {
    // 新增触摸事件处理
    handleTouchStart(e) {
      this.startY = e.touches[0].clientY;
    },
    handleTouchEnd(e) {
      if (!this.startY) return;
      const endY = e.changedTouches[0].clientY;
      const deltaY = endY - this.startY;
      const deltaX = Math.abs(e.changedTouches[0].clientX - this.startX);
      console.log('1',deltaY,deltaX,Math.abs(deltaY))

      // 垂直滑动距离大于30px且水平滑动小于50px时才触发
      if (Math.abs(deltaY) > 50 && deltaX < 400) {
        if (deltaY > 0) { // 向下滑动
          this.$router.push('/'); // 跳转
        } else if (deltaY < 0) { // 向上滑动
          this.$router.push('/about.html'); // 跳转
        }
      }
      this.startY = null;
    },
    // 新增滚轮处理函数
    handleWheelScroll(e) {
      if (e.ctrlKey || e.metaKey) return; // 过滤组合键操作
      if (e.deltaY > 0) { // 检测向下滚动
        this.$router.push('/about.html');
      }else if (e.deltaY < 0) { // 检测向上滚动
        this.$router.push('/'); // 跳转
      }
    },
    handleKeyDown(e) {
      // 阻止Ctrl+加号/减号/鼠标滚轮
      if ((e.ctrlKey === true || e.metaKey) &&
          (e.keyCode === 61 || e.keyCode === 107 ||
              e.keyCode === 173 || e.keyCode === 109 ||
              e.keyCode === 187  || e.keyCode === 189)) {
        e.preventDefault();
      }
    },
    handleWheel(e) {
      if (e.ctrlKey || e.metaKey) {
        e.preventDefault();
      }
    },
    handleTouchMove(e) {
      if (e.scale !== 1) {
        e.preventDefault();
      }
    },
    getinfo() {
      this.box = document.querySelector(".box");
      this.oli = document.querySelectorAll(".box ul li")
      this.butL = document.querySelector(".butL");
      this.butR = document.querySelector(".butR");
    },
    butLclick() {
      if (this.flag) {
        // 截取最后一个 放在第一位
        var last = this.lists.pop();
        this.lists.unshift(last);
        this.common();
      }
    },
    async butRclick() {
      if (this.flag) {
        // 截取第一个 放在最后一位
        var first = this.lists.shift();
        this.lists.push(first);
        await this.common();
      }
    },
    common() {
      for (var i = 0; i < this.lists.length; i++) {
        // 更换类名 就相当于更换位置
        this.oli[i].className = this.lists[i];
      }
    },
  },
};
</script>
<style>
@media (max-width: 768px) {
  .dbeijing{
    z-index: 0!important;
  }
  .box {
    width: 0px !important;
    height: 0px !important;
    position: absolute; /* 改为绝对定位 */
    top: 51%;
    left: 25%;
    transform: translate(-50%, -50%); /* 精确居中定位 */
    margin: 0; /* 移除原有margin */
    display: none;
  }
  .back1 {
    position: absolute;
    top: 25% !important;
    left: 38% !important;
    z-index: 0;
    width: 250px;
    transform:  translateX(-50%)!important; /* 精确居中定位 */
  }
  .back2 {
    position: absolute;
    top: 50%!important;
    left: 38%!important;
    z-index: 0;
    width: 250px;
    transform:  translateX(-50%)!important; /* 精确居中定位 */
  }
  .buttons{
    display: none;
  }
}
.show5,
.show6,
.show7,
.show8 {
  margin-right: 9999px;
}
* {
  margin: 0;
  padding: 0;
  list-style: none;
}
html, body {
  overflow: hidden;
  width: 100%;
  height: 100%;
}
.box {
  width: 310px;
  height: 570px; /* 改为自适应高度 */
  position: absolute; /* 改为绝对定位 */
  top: 51%;
  left: 25%;
  transform: translate(-50%, -50%); /* 精确居中定位 */
  margin: 0; /* 移除原有margin */
}
.name-tag {
  position: absolute;
  bottom: -20px; /* 根据图片高度调整偏移量 */
  left: 50%;
  transform: translateX(-50%);
  font-size: 18px;
  color: #333;
  font-weight: bold;
  white-space: nowrap;
  background: rgba(255,255,255,0.8);
  padding: 4px 12px;
  border-radius: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}
.show0 .name-tag,
.show4 .name-tag {
  bottom: -35px; /* 小尺寸图片减少偏移 */
  left: 120px;
}
.show1 img {
  object-fit: contain;
  height: 280px;  /* 统一高度 */
  width: 280px;   /* 新增固定宽度 */
}
.show3 img {  /* 新增图片比例控制 */
  object-fit: contain;
  height: 380px;
  width: 380px;   /* 新增固定宽度 */
}
.show0 img {  /* 新增尺寸控制 */
  object-fit: contain;
  height: 280px;
  width: 280px;
}
.show2 img {  /* 新增尺寸控制 */
  object-fit: contain;
  height: 280px;
  width: 280px;
}
.show4 img {  /* 新增图片比例控制 */
  object-fit: contain;
  height: 280px;
  width: 280px;
}
.show0 {
  transform: translateX(-0%) scale(0.75) !important;  /* 新增左移效果 */
}
.show1 {
  transform: translateX(-0%) scale(0.8) !important;  /* 新增左移效果 */
}
.show3 {
  transform: translateX(95%) scale(0.8) !important;  /* 新增左移效果 */
}

.show4 {
  transform: translateX(-35%) scale(0.75) !important;  /* 增强左移幅度 */
}
.show1 .name-tag {
  bottom: -35px; /* 中等尺寸图片适配 */
  left: 170px;
}
.show3 .name-tag {
  bottom: -35px; /* 中等尺寸图片适配 */
  left: 180px;
}
.show2 .name-tag {
  bottom: -40px; /* 最大尺寸图片增加偏移 */
}



.box ul li {
  height: auto !important; /* 取消固定高度 */
  position: relative; /* 为绝对定位标签提供参照 */
  overflow: visible; /* 确保标签可见 */
  /*过渡移动的动画*/
  transition: all 0.5s linear;
  transform: scale(0.8); /* 新增全局缩放 */

}



</style>